/* eslint-disable */

import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import Typewriter from 'typewriter-effect';
import Fade from 'react-reveal';
import endpoints from '../constants/endpoints';
import Social from './Social';
import FallbackSpinner from './FallbackSpinner';

const styles = {
  // Container that holds the layers and the text
  viewport: {
    position: 'relative',
    height: '100vh',
    width: '100vw',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  // Common style for background layers
  bgLayer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    transition: 'opacity 2s ease-in-out', // The "Clean Fade" duration
    zIndex: -1, // Keep behind text
  },
  contentBox: {
    zIndex: 1,
    padding: '25px',
    borderRadius: '25px',
    textAlign: 'center',
  }
};

function Home() {
  const [data, setData] = useState(null);
  const [projects, setProjects] = useState([]);
  const [index, setIndex] = useState(0);
  const theme = useContext(ThemeContext);

  useEffect(() => {
    fetch(endpoints.home).then(res => res.json()).then(setData);
    fetch(endpoints.projects).then(res => res.json()).then(res => {
      setProjects(res.projects.filter((project) => project.IsShowableToHomePage).sort(() => Math.random() - 0.5))
    });
  }, []);

  useEffect(() => {
    if (projects.length > 0) {
      const interval = setInterval(() => {
        setIndex((prev) => (prev + 1) % projects.length);
      }, 4000);
      return () => clearInterval(interval);
    }
  }, [projects]);

  if (!data || projects.length === 0) return <FallbackSpinner />;

  return (
    <div style={styles.viewport}>
      {/* 1. Background Layers for Crossfade */}
      {projects.map((project, i) => (
        <div
          key={project.title || i}
          style={{
            ...styles.bgLayer,
            backgroundImage: `url(${project.image})`,
            // If this is the current index, show it; otherwise, hide it
            opacity: i === index ? 1 : 0,
          }}
        />
      ))}

      {/* 2. Dark Overlay (to make text pop) */}
      <div style={{
        ...styles.bgLayer,
        backgroundColor: 'rgba(0,0,0,0.3)', // Optional tint
        zIndex: 0 
      }} />

      {/* 3. Main Content */}
      <Fade>
        <div style={{ ...styles.contentBox, backgroundColor: theme.backgroundOp }}>
          <h1 style={{ fontSize: '5em' }}>{data?.name}</h1>
          <Typewriter
            options={{
              strings: data?.roles,
              autoStart: true,
              loop: true,
            }}
          />
          <Social />
        </div>
      </Fade>
    </div>
  );
}

export default Home;